import {
  COUNTRY_ID_BY_CODE,
  COUNTRY_OPTIONS_BY_ID,
} from "Utilities/Address/networkCountryOptions";

import { isAddressVerified } from "./toHookValue";
import useHookValue from "../hooks/useHookValue";

// Keep the surface's own `values` shape a clean boolean (the network
// getSettings endpoint returns the raw DB tinyint). The hook input is coerced
// independently by `toHookValue`; both share `isAddressVerified` so they can't
// diverge.
export const seedCountryIDAddressValues = (src) => ({
  street: src?.street || "",
  city: src?.city || "",
  state: src?.state || "",
  zip: src?.zip || "",
  plus4: src?.plus4 || "",
  countryID: src?.countryID || 1,
  isVerified: isAddressVerified(src?.isVerified),
  verificationProvider: src?.verificationProvider || "",
  verifiedAt: src?.verifiedAt || "",
  validationSkipped: src?.validationSkipped || "",
});

export const mergeCountryIDAddressDelta = (prev, delta) => {
  const next = { ...prev };
  if ("addr1" in delta) next.street = delta.addr1;
  if ("city" in delta) next.city = delta.city;
  if ("state" in delta) next.state = delta.state;
  if ("zip" in delta) next.zip = delta.zip;
  if ("plus4" in delta) next.plus4 = delta.plus4;
  if (typeof delta.country === "string") {
    const id = COUNTRY_ID_BY_CODE[delta.country];
    if (id) next.countryID = id;
  }
  if ("isVerified" in delta) next.isVerified = delta.isVerified;
  if ("verificationProvider" in delta)
    next.verificationProvider = delta.verificationProvider;
  if ("verifiedAt" in delta) next.verifiedAt = delta.verifiedAt;
  if ("validationSkipped" in delta)
    next.validationSkipped = delta.validationSkipped;
  return next;
};

export const useCountryIDHookValue = (values) => {
  const countryISO =
    COUNTRY_OPTIONS_BY_ID[values.countryID]?.countryCode || "US";
  return useHookValue({ ...values, addr1: values.street }, countryISO);
};
